﻿import NotificationHandler from './handler/NotificationHandler';

window.NotificationHandler = NotificationHandler;